var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-divider'),_c('div',{staticStyle:{"padding-top":"8px"}},[_c('el-radio-group',{attrs:{"size":_vm.size},on:{"input":_vm.change},model:{value:(_vm.unit),callback:function ($$v) {_vm.unit=$$v},expression:"unit"}},[_c('el-radio',{attrs:{"label":"kg"}},[_vm._v("kg")]),_c('el-radio',{attrs:{"label":"m3"}},[_vm._v("m³")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }